import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  LOGIN_ERROR,
  COMPANY_SIGNUP,
  COMPANY_SIGNUP_SUCCESS,
  COMPANY_SIGNUP_ERROR,
  COMPANY_SETTING,
  COMPANY_SETTING_SUCCESS,
  ACCESS_SETTING,
  ACCESS_SETTING_SUCCESS,
  USER_DETAILS_SUCCESS,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCESS,
  CHANGE_USER_PASSWORD_ERROR,
  REDIRECT_LOGIN,
  REDIRECT_LOGIN_SUCCESS,
  REDIRECT_LOGIN_ERROR,
} from "./actionTypes"

export const LoginUser = (data, navigate) => {
  return {
    type: LOGIN_USER,
    payload: { data, navigate },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}
export const companySignup = (data, history) => {
  return {
    type: COMPANY_SIGNUP,
    payload: { data, history },
  }
}

export const companySignupError = error => {
  return {
    type: COMPANY_SIGNUP_ERROR,
    payload: error,
  }
}
export const companySignupSuccess = user => {
  return {
    type: COMPANY_SIGNUP_SUCCESS,
    payload: user,
  }
}

export const loginError = error => {
  return {
    type: LOGIN_ERROR,
    payload: error,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}
export const LoginUserData = data => {
  return {
    type: COMPANY_SETTING,
    payload: { data },
  }
}
export const loginUserSuccess = data => {
  return {
    type: COMPANY_SETTING_SUCCESS,
    payload: { data },
  }
}

export const LoginAccessSetting = data => {
  return {
    type: ACCESS_SETTING,
    payload: { data },
  }
}
export const LoginAccessSettingSuccess = data => {
  return {
    type: ACCESS_SETTING_SUCCESS,
    payload: { data },
  }
}

export const LoginAccessUserDetails = data => {
  return {
    type: USER_DETAILS_SUCCESS,
    payload: { data },
  }
}
export const userpasswordchange = (data, callback) => {
  return {
    type: CHANGE_USER_PASSWORD,
    payload: data,
    callback,
  }
}
export const userpasswordchangeSuccess = data => {
  return {
    type: CHANGE_USER_PASSWORD_SUCCESS,
    payload: data,
  }
}
export const userpasswordchangeError = data => {
  return {
    type: CHANGE_USER_PASSWORD_ERROR,
    payload: data,
  }
}

// aplication once click redirect login to dashboard or verify screen

export const redirect_login = (data, history) => {
  return {
    type: REDIRECT_LOGIN,
    payload: {data, history},
  }
}
export const redirect_loginSuccess = (data, history) => {
  return {
    type: REDIRECT_LOGIN_SUCCESS,
    payload: {data, history},
  }
}
export const redirect_loginError = data => {
  return {
    type: REDIRECT_LOGIN_ERROR,
    payload: data,
  }
}
